export { BvlBreadcrumbComponent as BvlBreadcrumb } from './breadcrumb.component';
export { BvlBreadcrumbModule } from './breadcrumb.module';
